import React from 'react';
import { Breadcrumb, NeoDateRangePicker, NeoButton } from "../../../components/Common";
import { useSalesSearch } from './hooks/useSalesSearch';
import { SalesTable } from './components/SalesTable';

/**
 * SalesPage
 * Página de Vendas — mesmo padrão de Receivables/Payables.
 */
const SalesPage = () => {
    document.title = "Vendas | NeoApp - Sistema de Gestão";

    const {
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        sales,
        loading,
        hasMore,
        loadMore,
        aggregates,
        handleSearch,
        hasSearched
    } = useSalesSearch();

    return (
        <React.Fragment>
            {/* TOP BAR: Cabeçalho & Filtro de Período */}
            <div className="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between mb-4 gap-3">
                <div>
                    <Breadcrumb title="Vendas" />
                    <p className="text-muted mb-0 font-size-13 mt-0.5">
                        Histórico de vendas realizadas, itens e formas de pagamento do período.
                    </p>
                </div>

                <div className="d-flex flex-column flex-sm-row align-items-sm-center gap-2 flex-shrink-0">
                    <NeoDateRangePicker
                        startDate={startDate}
                        endDate={endDate}
                        onChange={({ startDate: start, endDate: end }) => {
                            if (start !== undefined) setStartDate(start);
                            if (end !== undefined) setEndDate(end);
                        }}
                        size="sm"
                        className="mb-0 neo-daterangepicker-filter"
                        placeholder="Selecione o período..."
                    />
                    <NeoButton
                        variant="primary"
                        onClick={handleSearch}
                        loading={loading}
                        disabled={!startDate || !endDate}
                        title="Buscar"
                        icon="mdi-magnify"
                        size="sm"
                        square
                        className="neo-filter-search-btn"
                    />
                </div>
            </div>

            <div className="border-top mb-4"></div>

            {/* ═══ TABELA ═══ */}
            <SalesTable
                sales={sales}
                hasMore={hasMore}
                loadMore={loadMore}
                loading={loading}
                aggregates={aggregates}
                hasSearched={hasSearched}
            />
        </React.Fragment>
    );
};

export default SalesPage;
